// import React, { useContext, useState } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { GlobalStateContext } from './GlobalStateContext';
// import { format } from 'date-fns';

// const TmroPage = () => {
//   const {
//     feedlots,
//     handleFeedlotSelect,
//     fetchFieldsForDate,
//     fetchCombinedValuesForDate,
//   } = useContext(GlobalStateContext);

//   const [selectedDate, setSelectedDate] = useState(null);
//   const [combinedData, setCombinedData] = useState(null);
//   const [individualData, setIndividualData] = useState(null);
//   const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//   const [error, setError] = useState(null);

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//   };

//   const handleFeedlotChange = (event) => {
//     handleFeedlotSelect(event);
//     const feedlotIndex = event.target.value;
//     const feedlot = feedlots[feedlotIndex];
//     setSelectedFeedlot(feedlot);
//   };

//   const fetchIndividualData = async () => {
//     if (selectedFeedlot && selectedDate) {
//       try {
//         const formattedDate = format(selectedDate, 'yyMMdd');
//         const data = await fetchFieldsForDate(selectedFeedlot.TMRID, formattedDate);
//         setIndividualData(data);
//       } catch (error) {
//         setError(error.message);
//       }
//     }
//   };

//   const fetchCombinedData = async () => {
//     if (selectedFeedlot && selectedDate) {
//       const fieldsToSum = ['field1', 'field2', 'field3']; // Replace with your actual field names
//       try {
//         const formattedDate = format(selectedDate, 'yyMMdd');
//         const data = await fetchCombinedValuesForDate(selectedFeedlot.TMRID, formattedDate, fieldsToSum);
//         setCombinedData(data);
//       } catch (error) {
//         setError(error.message);
//       }
//     }
//   };

//   return (
//     <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-300 h-max p-3">
//       {/* Welcome Section */}
//       <div className="col-span-2 md:col-span-2 lg:col-span-4 bg-gradient-to-r from-#2f4858 to-#33658a p-6 rounded-lg shadow-3xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
//         <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
//           <div>
//             <h1 className="text-3xl font-bold mb-2 lg:mb-0">SarBatch Dashboard</h1>
//             <p className="text-lg">Explore detailed graphs and historical data for each component, including insights from the past 7 days.</p>
//           </div>
//           <div className="mt-4 lg:mt-0 shadow-3xl rounded-lg">
//             <button className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
//               Learn More
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Feedlot Selection */}
//       {feedlots.length > 0 && (
//         <div className="col-span-2 lg:col-span-4 bg-slate-400 bg-opacity-50 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
//           <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Feedlot:</h2>
//           <select className="w-full p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl" onChange={handleFeedlotChange}>
//             <option value="">-- Select a Feedlot --</option>
//             {feedlots.map((feedlot, index) => (
//               <option key={index} value={index}>
//                 {feedlot.Name || `Feedlot ${index + 1}`}
//               </option>
//             ))}
//           </select>
//         </div>
//       )}

//       {/* Date Picker and Buttons */}
//       <div className="col-span-2 lg:col-span-4 bg-slate-400 bg-opacity-50 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
//         <h2 className="text-xl font-semibold text-gray-100 mb-4">Select Date:</h2>
//         <DatePicker
//           selected={selectedDate}
//           onChange={handleDateChange}
//           dateFormat="yyyy/MM/dd"
//           className="w-full p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4"
//         />
//         <div className="flex space-x-4">
//           <button
//             className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition"
//             onClick={fetchIndividualData}
//           >
//             Fetch Individual Data
//           </button>
//           <button
//             className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition"
//             onClick={fetchCombinedData}
//           >
//             Fetch Combined Data
//           </button>
//         </div>
//         {error && <p className="text-red-500">{error}</p>}
//       </div>

//       {/* Display Data */}
//       <div className="col-span-2 lg:col-span-4">
//         <h2 className="text-xl font-semibold text-gray-700 mb-4">Data:</h2>
//         {individualData && (
//           <div>
//             <h3 className="text-lg font-semibold text-gray-700 mb-2">Individual Data:</h3>
//             <pre className="bg-gray-100 p-4 rounded-lg shadow-3xl">{JSON.stringify(individualData, null, 2)}</pre>
//           </div>
//         )}
//         {combinedData && (
//           <div>
//             <h3 className="text-lg font-semibold text-gray-700 mb-2">Combined Data:</h3>
//             <pre className="bg-gray-100 p-4 rounded-lg shadow-3xl">{JSON.stringify(combinedData, null, 2)}</pre>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TmroPage;




// import React, { useContext, useState, useEffect } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { GlobalStateContext } from './GlobalStateContext';
// import { format } from 'date-fns';
// import LoadingAnimation from './LoadingAnimation';

// const TmroPage = () => {
//   const {
//     feedlots,
//     handleFeedlotSelect,
//     fetchFieldsForDate,
//     fetchCombinedValuesForDate,
//   } = useContext(GlobalStateContext);

//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedBatch, setSelectedBatch] = useState('');
//   const [combinedData, setCombinedData] = useState(null);
//   const [individualData, setIndividualData] = useState({});
//   const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [minimumLoadingTimePassed, setMinimumLoadingTimePassed] = useState(false);
//   const [inventoryGain, setInventoryGain] = useState(null);

//   // Define your fields to display
//   const fieldsToDisplay = ['Batch','Grain', 'LSCAdded', 'WaterAdded', 'IsFlow1', 'IsFlow2', 'IsFlow3', 'IsHead', 'LSCFeedPerDay', 'LSCTarget', 'LSCVolume', 'MoistBeg', 'MoistEnd', 'MoistTarg', 'OperDate', 'Prod1Added', 'Prod1FeedPerDay', 'Prod1Target', 'Prod1Volume', 'Prod2Added', 'Prod2FeedPerDay', 'Prod2Target', 'Prod2Volume', 'Prod3Added', 'Prod3FeedPerDay', 'Prod3Target', 'Prod3Volume', 'RationName', 'RationName', 'RationSelection', 'SarFreshAdded', 'SarFreshFeedPerDay', 'SarFreshTarget', 'SarFreshVolume', 'UnitNo', 'WasPaused', 'WasStopped', 'WaterTarg']; // Add your specific fields here

//   // Mapping object for field labels
//   const fieldLabelMapping = {
//     Grain: 'Grain Amount',
//     LSCAdded: 'LSC Added',
//     WaterAdded: 'Water Added',
//     // Add more fields as needed
//   };

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//   };

//   const handleFeedlotChange = (event) => {
//     handleFeedlotSelect(event);
//     const feedlotIndex = event.target.value;
//     const feedlot = feedlots[feedlotIndex];
//     setSelectedFeedlot(feedlot);
//   };

//   const handleBatchChange = (event) => {
//     setSelectedBatch(event.target.value);
//   };

//   const startLoading = () => {
//     setLoading(true);
//     setMinimumLoadingTimePassed(false);
//     setTimeout(() => {
//       setMinimumLoadingTimePassed(true);
//     }, 3000); // Set minimum loading time to 2 seconds
//   };

//   const stopLoading = () => {
//     setLoading(false);
//   };

//   const fetchIndividualData = async () => {
//     startLoading(true);
//     if (selectedFeedlot && selectedDate) {
//       try {
//         const formattedDate = format(selectedDate, 'yyMMdd');
//         const data = await fetchFieldsForDate(selectedFeedlot.TMRID, formattedDate);
//         setIndividualData(data);
//         setSelectedBatch(Object.keys(data)[0] || '');
//       } catch (error) {
//         setError(error.message);
//       } finally {
//         if (minimumLoadingTimePassed) {
//           stopLoading();
//         } else {
//           const loadingTimeout = setTimeout(stopLoading, 2000); // Ensure minimum loading time is respected
//           return () => clearTimeout(loadingTimeout);
//         }
//       }
//     }
//   };

//   const fetchCombinedData = async () => {
//     startLoading(true);
//     if (selectedFeedlot && selectedDate) {
//       const fieldsToSum = ['Grain', 'LSCAdded', 'WaterAdded']; // Replace with your actual field names
//       try {
//         const formattedDate = format(selectedDate, 'yyMMdd');
//         const data = await fetchCombinedValuesForDate(selectedFeedlot.TMRID, formattedDate, fieldsToSum);
//         setCombinedData(data);
//       } catch (error) {
//         setError(error.message);
//       } finally {
//         if (minimumLoadingTimePassed) {
//           stopLoading();
//         } else {
//           const loadingTimeout = setTimeout(stopLoading, 2000); // Ensure minimum loading time is respected
//           return () => clearTimeout(loadingTimeout);
//         }
//       }
//     }
//   };

//   useEffect(() => {
//     if (selectedDate && selectedFeedlot) {
//       fetchIndividualData();
//       fetchCombinedData();
//     }
//   }, [selectedDate, selectedFeedlot]);

//   useEffect(() => {
//     if (combinedData) {
//       const { LSCAdded, WaterAdded, Grain } = combinedData;

//       // Perform calculations
//       const lscLbs = (LSCAdded / 128) * 9.18;
//       const waterLbs = WaterAdded * 8.3;
//       const totalLbs = lscLbs + waterLbs;
//       const inventoryGainValue = totalLbs / Grain;

//       setInventoryGain(inventoryGainValue);
//     }
//   }, [combinedData]);

//   return (
//     <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-900 h-fit p-3">
//       {/* Welcome Section */}
//       <div className="col-span-2 md:col-span-2 lg:col-span-4 bg-gradient-to-r from-[#2f4858] to-[#33658a] p-6 rounded-lg shadow-3xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
//         <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
//           <div>
//             <h1 className="text-3xl font-bold mb-2 lg:mb-0">SarBatch Dashboard</h1>
//             <p className="text-lg">Explore detailed graphs and historical data for each component, including insights from the past 7 days.</p>
//           </div>
//           <div className="mt-4 lg:mt-0 shadow-3xl rounded-lg">
//             <button className="bg-[#33658a] text-[#2f4858] px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
//               Learn More
//             </button>
//           </div>
//         </div>
//       </div>


//       {/* Date Picker and Buttons */}
//       <div className="col-span-2 lg:col-span-1 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl z-10">
//         <h2 className="text-xl font-semibold text-gray-100 mb-4">Select Date:</h2>
//         <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
//       <DatePicker
//         selected={selectedDate}
//         onChange={handleDateChange}
//         dateFormat="yyyy/MM/dd"
//         placeholderText="yyyy/mm/dd"
//         className="bg-transparent outline-none w-full"
//         />
//       <svg className="w-8 h-8 text-gray-100 cursor-pointer" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7.75 2.5C7.75 2.08579 7.41421 1.75 7 1.75C6.58579 1.75 6.25 2.08579 6.25 2.5V4.07926C4.81067 4.19451 3.86577 4.47737 3.17157 5.17157C2.47737 5.86577 2.19451 6.81067 2.07926 8.25H21.9207C21.8055 6.81067 21.5226 5.86577 20.8284 5.17157C20.1342 4.47737 19.1893 4.19451 17.75 4.07926V2.5C17.75 2.08579 17.4142 1.75 17 1.75C16.5858 1.75 16.25 2.08579 16.25 2.5V4.0129C15.5847 4 14.839 4 14 4H10C9.16097 4 8.41527 4 7.75 4.0129V2.5Z" fill="#61626E"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 11.161 22 10.4153 21.9871 9.75H2.0129C2 10.4153 2 11.161 2 12V14C2 17.7712 2 19.6569 3.17157 20.8284C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14V12ZM14 12.25C13.0335 12.25 12.25 13.0335 12.25 14V16C12.25 16.9665 13.0335 17.75 14 17.75C14.9665 17.75 15.75 16.9665 15.75 16V14C15.75 13.0335 14.9665 12.25 14 12.25ZM14 13.75C13.8619 13.75 13.75 13.8619 13.75 14V16C13.75 16.1381 13.8619 16.25 14 16.25C14.1381 16.25 14.25 16.1381 14.25 16V14C14.25 13.8619 14.1381 13.75 14 13.75ZM10.787 12.3071C11.0673 12.4232 11.25 12.6967 11.25 13V17C11.25 17.4142 10.9142 17.75 10.5 17.75C10.0858 17.75 9.75 17.4142 9.75 17V14.8107L9.53033 15.0303C9.23744 15.3232 8.76256 15.3232 8.46967 15.0303C8.17678 14.7374 8.17678 14.2626 8.46967 13.9697L9.96967 12.4697C10.1842 12.2552 10.5068 12.191 10.787 12.3071Z" fill="#61626E"></path> </g></svg>
//     </label>
//         <div className="flex space-x-4 mb-4">
//           {/* <button
//             className="bg-[#33658a] text-[#2f4858] px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition"
//             onClick={fetchIndividualData}
//           >
//             Fetch Individual Data
//           </button>
//           <button
//             className="bg-[#33658a] text-[#2f4858] px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition"
//             onClick={fetchCombinedData}
//           >
//             Fetch Combined Data
//           </button> */}
//         </div>
//         {error && <p className="text-red-500">{error}</p>}
//       </div>
//       {/* Feedlot Selection */}
//       {feedlots.length > 0 && (
//         <div className="col-span-2 lg:col-span-3 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
//           <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Feedlot:</h2>
//           <select className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl" onChange={handleFeedlotChange}>
//             <option value="">-- Select a Feedlot --</option>
//             {feedlots.map((feedlot, index) => (
//               <option key={index} value={index}>
//                 {feedlot.Name || `Feedlot ${index + 1}`}
//               </option>
//             ))}
//           </select>
//         </div>
//       )}

//       {/* Loading Animation */}
//       {loading && (
//         <div className="col-span-2 lg:col-span-4 m-10 flex justify-center items-center">
//             <LoadingAnimation />
//           </div>
//         )}

//         <div className='col-span-2 lg:col-span-4 bg-slate-300 p-4 rounded-lg shadow-3xl'> 
//       {/* Batch Selection */}
//       {!loading && selectedFeedlot && selectedDate && (
//         <div className="col-span-2 lg:col-span-4">
//           <h2 className="text-xl font-semibold text-gray-700 mb-4">Select a Batch:</h2>
//           <select
//             value={selectedBatch}
//             onChange={handleBatchChange}
//             className="w-full p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4"
//           >
//             {Object.keys(individualData).map((batch) => (
//               <option key={batch} value={batch}>
//                 {batch}
//               </option>
//             ))}
//           </select>
//         </div>
//       )}



//         {/* Display Data */}
//         {!loading && selectedFeedlot && selectedDate && selectedBatch && (
//           <div className="col-span-2 lg:col-span-4">
//             {combinedData && (
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-700 mb-2">All Batches Combined Data:</h3>
//                 <pre className="bg-gray-100 p-4 rounded-lg shadow-3xl">{JSON.stringify(combinedData, null, 2)}</pre>
//                 <div className="mb-2 text-gray-100">
//                 <strong>Inventory Gain:</strong> {inventoryGain !== null ? inventoryGain.toFixed(3) : 'N/A'}
//                 </div>
//               </div>
//             )}
//             {individualData[selectedBatch] && (
//               <div>
//                 <h3 className="text-lg font-semibold pt-4 text-gray-700 mb-2">Individual Data for {selectedBatch}:</h3>
//                 <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
//                   {fieldsToDisplay.map((field) => (
//                     <div key={field} className="bg-white p-4 rounded-lg shadow-md">
//                       <h4 className="text-sm font-medium text-gray-900">{fieldLabelMapping[field] || field}</h4>
//                       <p className="text-sm text-gray-700">{JSON.stringify(individualData[selectedBatch][field], null, 2)}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
          
//         </div>
//       </div>
//   );
// };

// export default TmroPage;



// import React, { useContext, useState, useEffect } from 'react';
// import 'react-datepicker/dist/react-datepicker.css';
// import { GlobalStateContext } from './GlobalStateContext';
// import DatePicker from 'react-datepicker';
// import { format } from 'date-fns';
// import BatchGraph from './BatchGraph';
// import InventoryGainGraph from './InventoryGainGraph';

// const TmroPage = () => {
//   const {
//     feedlots,
//     handleFeedlotSelect,
//     selectedFeedlot,
//     fetchFieldsForDate,
//     convertTimestamp,
//   } = useContext(GlobalStateContext);

//   const [selectedDate, setSelectedDate] = useState('');
//   const [fieldsData, setFieldsData] = useState([]);
//   const [combinedData, setCombinedData] = useState({});
//   const [selectedBatch, setSelectedBatch] = useState(null);
//   const [selectedField, setSelectedField] = useState('Grain');
//   const [error, setError] = useState(null);

//   // Define the fields you want to display and sum
//   const fieldsToSum = ['Grain', 'LSCAdded', 'WaterAdded', ];

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//   };
//   const handleFieldSelect = (event) => {
//     setSelectedField(event.target.value);
//   };

//   const handleBatchSelect = (event) => {
//     const selectedBatchId = event.target.value;
//     const selectedBatchData = fieldsData.find(batch => batch.id === selectedBatchId);
//     setSelectedBatch(selectedBatchData);
//   };


//   const fetchCombinedValuesForDate = (fieldsData, fieldsToSum) => {
//     console.log('Calculating combined values from fields data');

//     const combinedValues = fieldsToSum.reduce((acc, field) => {
//       acc[field] = 0;
//       return acc;
//     }, {});

//     fieldsData.forEach((data) => {
//       fieldsToSum.forEach((field) => {
//         if (data.hasOwnProperty(field)) {
//           combinedValues[field] += Number(data[field]);
//         }
//       });
//     });

//     console.log(`Combined values: ${JSON.stringify(combinedValues)}`);
//     return combinedValues;
//   };

//   const fetchData = async () => {
//     if (selectedFeedlot && selectedDate) {
//       const date = new Date(selectedDate);
//       const formattedDate = `${date.getFullYear().toString().slice(2)}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`;

//       try {
//         const fields = await fetchFieldsForDate(selectedFeedlot.TMRID, formattedDate);
//         setFieldsData(fields);

//         const combinedValues = fetchCombinedValuesForDate(fields, fieldsToSum);
//         setCombinedData(combinedValues);
//       } catch (err) {
//         console.error('Error fetching data:', err);
//         setError(err.message);
//       }
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [selectedDate, selectedFeedlot]);

//   return (
//   <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 bg-gray-900 h-fit p-4">
//     {/* Welcome Section */}
//     <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-gradient-to-r from-[#2f4858] to-[#33658a] p-6 rounded-lg shadow-3xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
//       <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
//         <div>
//           <h1 className="text-3xl font-bold mb-2 lg:mb-0">SarBatch Dashboard</h1>
//           <p className="text-lg">Explore detailed graphs and historical data for each component, including insights from the past 7 days.</p>
//         </div>
//         <div className="mt-4 lg:mt-0">
//           <button className="bg-[#33658a] text-[#2f4858] px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
//             Learn More
//           </button>
//         </div>
//       </div>
//     </div>

//     {/* Date Picker */}
//     <div className="col-span-2 md:col-span-1 lg:col-span-1 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl z-10 flex flex-col items-center">        
//       <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Date:</h2>
//       <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
//         <DatePicker
//           selected={selectedDate}
//           onChange={handleDateChange}
//           dateFormat="yyyy/MM/dd"
//           placeholderText="yyyy/mm/dd"
//           className="bg-transparent outline-none w-full"
//         />
//         <svg className="w-8 h-8 text-gray-100 cursor-pointer" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
//           <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
//           <g id="SVGRepo_iconCarrier"> 
//             <path d="M7.75 2.5C7.75 2.08579 7.41421 1.75 7 1.75C6.58579 1.75 6.25 2.08579 6.25 2.5V4.07926C4.81067 4.19451 3.86577 4.47737 3.17157 5.17157C2.47737 5.86577 2.19451 6.81067 2.07926 8.25H21.9207C21.8055 6.81067 21.5226 5.86577 20.8284 5.17157C20.1342 4.47737 19.1893 4.19451 17.75 4.07926V2.5C17.75 2.08579 17.4142 1.75 17 1.75C16.5858 1.75 16.25 2.08579 16.25 2.5V4.0129C15.5847 4 14.839 4 14 4H10C9.16097 4 8.41527 4 7.75 4.0129V2.5Z" fill="#61626E"></path> 
//             <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 11.161 22 10.4153 21.9871 9.75H2.0129C2 10.4153 2 11.161 2 12V14C2 17.7712 2 19.6569 3.17157 20.8284C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14V12ZM14 12.25C13.0335 12.25 12.25 13.0335 12.25 14V16C12.25 16.9665 13.0335 17.75 14 17.75C14.9665 17.75 15.75 16.9665 15.75 16V14C15.75 13.0335 14.9665 12.25 14 12.25ZM14 13.75C13.8619 13.75 13.75 13.8619 13.75 14V16C13.75 16.1381 13.8619 16.25 14 16.25C14.1381 16.25 14.25 16.1381 14.25 16V14C14.25 13.8619 14.1381 13.75 14 13.75ZM10.787 12.3071C11.0673 12.4232 11.25 12.6967 11.25 13V17C11.25 17.4142 10.9142 17.75 10.5 17.75C10.0858 17.75 9.75 17.4142 9.75 17V14.8107L9.53033 15.0303C9.23744 15.3232 8.76256 15.3232 8.46967 15.0303C8.17678 14.7374 8.17678 14.2626 8.46967 13.9697L9.96967 12.4697C10.1842 12.2552 10.5068 12.191 10.787 12.3071Z" fill="#61626E"></path> 
//           </g>
//         </svg>
//       </label>
//       {error && <p className="text-red-500 text-sm">Error: {error}</p>}
//     </div>

//     {/* Feedlot Selection */}
//     {feedlots.length > 0 && (
//       <div className="col-span-2 lg:col-span-3 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
//         <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Feedlot:</h2>
//         <select className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md" onChange={handleFeedlotSelect}>
//           <option value="">-- Select a Feedlot --</option>
//           {feedlots.map((feedlot, index) => (
//             <option key={index} value={index}>
//               {feedlot.Name || `Feedlot ${index + 1}`}
//             </option>
//           ))}
//         </select>
//       </div>
//     )}

//     {/* Data Display */}
//     <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
//       {fieldsData.length > 0 && (
//         <div className="mb-4">
//           <h3 className="text-lg font-semibold mb-2">Select a Field to Display:</h3>
//           <select className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md mb-4" onChange={handleFieldSelect}>
//             {fieldsToSum.map((field) => (
//               <option key={field} value={field}>
//                 {field}
//               </option>
//             ))}
//           </select>
//           <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl mb-4">
//             {fieldsData.length > 0 && <BatchGraph fieldsData={fieldsData} selectedField={selectedField} />}
//           </div>
//           <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl">
//             {fieldsData.length > 0 && <InventoryGainGraph fieldsData={fieldsData} selectedField={selectedField} />}
//           </div>
//         </div>
//       )}
//       </div>

//       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 col-span-2 md:col-span-3 lg:col-span-4 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-6 rounded-lg shadow-3xl">
//   <h2 className="text-2xl font-bold text-gray-100 mb-2 col-span-4">Data Display</h2>

//   {fieldsData.length > 0 && (
//     <div className="mb-6 col-span-4">
//       {Object.keys(combinedData).length > 0 && (
//         <div className="p-4 border border-gray-700 rounded-md bg-slate-800 col-span-2 mt-6 shadow-3xl mb-4">
//           <h3 className="text-lg font-semibold text-gray-200 mb-3">Combined Data:</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {fieldsToSum.map((field) => (
//               <div key={field} className="p-2 border border-gray-700 rounded-md bg-slate-700">
//                 <p className="text-sm text-gray-200">
//                   <strong>{field}:</strong> {combinedData[field]}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//       <h3 className="text-lg font-semibold text-gray-200 mb-3">Select a Batch:</h3>
//       <select className="w-full cursor-pointer p-3 rounded-md bg-slate-700 text-gray-200 border border-gray-500 shadow-md mb-4" onChange={handleBatchSelect}>
//         <option value="">-- Select a Batch --</option>
//         {fieldsData.map((data) => (
//           <option key={data.id} value={data.id}>
//             Batch Number: {data.Batch}
//           </option>
//         ))}
//       </select>
//       {selectedBatch && (
//         <div className="p-4 border border-gray-700 rounded-md bg-slate-800 shadow-3xl">
//           <h4 className="font-semibold text-gray-100 mb-2">Batch Number: {selectedBatch.Batch}</h4>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {Object.entries(selectedBatch).map(([key, value]) => (
//               <div key={key} className="p-2 border border-gray-700 rounded-md bg-slate-700">
//                 <p className="text-sm text-gray-200">
//                   <strong>{key}:</strong> {value}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   )}
// </div>



//   </div>



// );
// };


// export default TmroPage;


// //  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 bg-gray-900 h-fit p-4">
// //   {/* Welcome Section */}
// //   <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-gradient-to-r from-[#2f4858] to-[#33658a] p-6 rounded-lg shadow-3xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
// //     <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
// //       <div>
// //         <h1 className="text-3xl font-bold mb-2 lg:mb-0">SarBatch Dashboard</h1>
// //         <p className="text-lg">Explore detailed graphs and historical data for each component, including insights from the past 7 days.</p>
// //       </div>
// //       <div className="mt-4 lg:mt-0">
// //         <button className="bg-[#33658a] text-[#2f4858] px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
// //           Learn More
// //         </button>
// //       </div>
// //     </div>
// //   </div>

// //   {/* Date Picker */}
// //   <div className="col-span-2 md:col-span-1 lg:col-span-1 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl z-10 flex flex-col items-center">        
// //   <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Date:</h2>
// //     <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
// //        <DatePicker
// //          selected={selectedDate}
// //          onChange={handleDateChange}
// //          dateFormat="yyyy/MM/dd"
// //          placeholderText="yyyy/mm/dd"
// //          className="bg-transparent outline-none w-full"
// //          />
// //        <svg className="w-8 h-8 text-gray-100 cursor-pointer" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7.75 2.5C7.75 2.08579 7.41421 1.75 7 1.75C6.58579 1.75 6.25 2.08579 6.25 2.5V4.07926C4.81067 4.19451 3.86577 4.47737 3.17157 5.17157C2.47737 5.86577 2.19451 6.81067 2.07926 8.25H21.9207C21.8055 6.81067 21.5226 5.86577 20.8284 5.17157C20.1342 4.47737 19.1893 4.19451 17.75 4.07926V2.5C17.75 2.08579 17.4142 1.75 17 1.75C16.5858 1.75 16.25 2.08579 16.25 2.5V4.0129C15.5847 4 14.839 4 14 4H10C9.16097 4 8.41527 4 7.75 4.0129V2.5Z" fill="#61626E"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 11.161 22 10.4153 21.9871 9.75H2.0129C2 10.4153 2 11.161 2 12V14C2 17.7712 2 19.6569 3.17157 20.8284C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14V12ZM14 12.25C13.0335 12.25 12.25 13.0335 12.25 14V16C12.25 16.9665 13.0335 17.75 14 17.75C14.9665 17.75 15.75 16.9665 15.75 16V14C15.75 13.0335 14.9665 12.25 14 12.25ZM14 13.75C13.8619 13.75 13.75 13.8619 13.75 14V16C13.75 16.1381 13.8619 16.25 14 16.25C14.1381 16.25 14.25 16.1381 14.25 16V14C14.25 13.8619 14.1381 13.75 14 13.75ZM10.787 12.3071C11.0673 12.4232 11.25 12.6967 11.25 13V17C11.25 17.4142 10.9142 17.75 10.5 17.75C10.0858 17.75 9.75 17.4142 9.75 17V14.8107L9.53033 15.0303C9.23744 15.3232 8.76256 15.3232 8.46967 15.0303C8.17678 14.7374 8.17678 14.2626 8.46967 13.9697L9.96967 12.4697C10.1842 12.2552 10.5068 12.191 10.787 12.3071Z" fill="#61626E"></path> </g></svg>
// //      </label>
// //     {error && <p className="text-red-500 text-sm">Error: {error}</p>}
// //   </div>

// //   {/* Feedlot Selection */}
// //   {feedlots.length > 0 && (
// //     <div className="col-span-2 lg:col-span-3 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
// //       <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Feedlot:</h2>
// //       <select className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md" onChange={handleFeedlotSelect}>
// //         <option value="">-- Select a Feedlot --</option>
// //         {feedlots.map((feedlot, index) => (
// //           <option key={index} value={index}>
// //             {feedlot.Name || `Feedlot ${index + 1}`}
// //           </option>
// //         ))}
// //       </select>
// //     </div>
// //   )}

// //       {/* Data Display */}
// //       <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
// //         {fieldsData.length > 0 && (
// //       <div className="mb-4">
// //         <h3 className="text-lg font-semibold mb-2">Select a Field to Display:</h3>
// //         <select className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md mb-4" onChange={handleFieldSelect}>
// //           {fieldsToSum.map((field) => (
// //             <option key={field} value={field}>
// //               {field}
// //             </option>
// //           ))}
// //         </select>
// //         <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl mb-4">
// //          {fieldsData.length > 0 && <BatchGraph fieldsData={fieldsData} selectedField={selectedField} />}
// //         </div>
// //         <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl">
// //          {fieldsData.length > 0 && <InventoryGainGraph   fieldsData={fieldsData} selectedField={selectedField} />}
// //         </div>
// //       </div>
// //         )}
// // <h2 className="text-2xl font-bold text-gray-100 mb-6">Data Display</h2>
// // {fieldsData.length > 0 && (
// //   <div className="mb-6">
// //     <h3 className="text-lg font-semibold text-gray-200 mb-3">Select a Batch:</h3>
// //     <select
// //       className="w-full cursor-pointer p-3 rounded-md bg-slate-700 text-gray-200 border border-gray-500 shadow-md mb-4"
// //       onChange={handleBatchSelect}
// //     >
// //       <option value="">-- Select a Batch --</option>
// //       {fieldsData.map((data) => (
// //         <option key={data.id} value={data.id}>
// //           Batch Number: {data.Batch}
// //         </option>
// //       ))}
// //     </select>

// //     {selectedBatch && (
// //       <div className="p-4 border border-gray-700 rounded-md bg-slate-800">
// //         <h4 className="font-semibold text-gray-100">Batch Number: {selectedBatch.Batch}</h4>
// //         {Object.entries(selectedBatch).map(([key, value]) => (
// //           <p key={key} className="mb-1 text-sm text-gray-200">
// //             <strong>{key}:</strong> {value}
// //           </p>
// //         ))}
// //       </div>
// //     )}
// //   </div>
// // )}
// // {Object.keys(combinedData).length > 0 && (
// //   <div className="mt-6">
// //     <h3 className="text-lg font-semibold text-gray-200 mb-3">Combined Data:</h3>
// //     <ul className="text-sm text-gray-200">
// //       {fieldsToSum.map((field) => (
// //         <li key={field} className="mb-1">
// //           <strong>{field}:</strong> {combinedData[field]}
// //         </li>
// //       ))}
// //     </ul>
// //   </div>
// // )}

// //   </div>
// // </div>





import React, { useContext, useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { GlobalStateContext } from './GlobalStateContext';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import BatchGraph from './BatchGraph';
import InventoryGainGraph from './InventoryGainGraph';
import TimeSeriesGraph from './TimeSeriesGraph';

const TmroPage = () => {
  const {
    feedlots,
    handleFeedlotSelect,
    selectedFeedlot,
    fetchFieldsForDate,
    convertTimestamp,
    fetchEndOfDayVolume, 
    fetchPriorSevenDayDataTmro
  } = useContext(GlobalStateContext);

  const [selectedDate, setSelectedDate] = useState(null);
  const [volume, setVolume] = useState('');
  const [fieldsData, setFieldsData] = useState([]);
  const [combinedData, setCombinedData] = useState({});
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedFields, setSelectedFields] = useState({field: 'Grain', timeSeriesField: 'TankLevel'})
  const [error, setError] = useState(null);
  const [alert, setAlert] = useState(null);
  const [lastSevenDays, setLastSevenDays] = useState([])
  const [recentDate, setRecentDate] = useState('');

  // Define the fields you want to display and sum
  const fieldsToSum = ['Grain', 'LSCAdded', 'WaterAdded'];
    
  //array to hold the field options for timeSeriesGraph
  const last7DayFields = ['TankLevel', 'Batches', 'GrainTotal']

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleFieldChange = (e) => {
    setSelectedFields(oldVal => {
      if (e.target.name === 'field') {
        return {
          field: e.target.value,
          timeSeriesField: oldVal.timeSeriesField
        }
      } else if (e.target.name === 'timeSeriesField') {
        return {
          field: oldVal.field,
          timeSeriesField: e.target.value
        }
      } else {
        return {...oldVal}
      }
    })
};





//helper function for displaying units
const unit = (field) => {
  if (field === "Grain") {
    return " Lbs"
  } else if (field === "LSCAdded" ) {
    return " Oz"
  } else if (field === "WaterAdded" || field === "LSCVolume") {
    return " Gallons"
  } else return " "
};

  const handleBatchSelect = (event) => {
    const selectedBatchId = event.target.value;
    const selectedBatchData = fieldsData.find(batch => batch.id === selectedBatchId);
  
    if (selectedBatchData) {
      const roundedBatchData = {};
  
      Object.keys(selectedBatchData).forEach((key) => {
        if (fieldsToSum.includes(key)) {
          roundedBatchData[key] = Math.round(Number(selectedBatchData[key]));
        } else {
          roundedBatchData[key] = selectedBatchData[key];
        }
      });
  
      setSelectedBatch(roundedBatchData);
    }
  };
  

  const fetchCombinedValuesForDate = (fieldsData, fieldsToSum) => {
    console.log('Calculating combined values from fields data');
  
    const combinedValues = fieldsToSum.reduce((acc, field) => {
      acc[field] = 0;
      return acc;
    }, {});
  
    fieldsData.forEach((data) => {
      fieldsToSum.forEach((field) => {
        if (data.hasOwnProperty(field)) {
          combinedValues[field] += Number(data[field]);
        }
      });
    });
  
    // Round and remove unnecessary zeros
    Object.keys(combinedValues).forEach((key) => {
      combinedValues[key] = Math.round(combinedValues[key]);
    });
  
    return combinedValues;
  };
  

  const fetchData = async () => {
    //could just put the fields in the dependency array and only fetch the default on on the initial render
    if (selectedFeedlot) {


      let date = null
      if (selectedDate) {
        date = new Date(selectedDate);
      } else {
        date = new Date(Date.now())
      }
      let formattedDate = `${date.getFullYear().toString().slice(2)}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`;

      try {
        const fields = await fetchFieldsForDate(selectedFeedlot.TMRID, formattedDate);

        const volumeData = await fetchEndOfDayVolume(selectedFeedlot.TMRID, formattedDate)

        const priorSevenDays = await fetchPriorSevenDayDataTmro(selectedFeedlot.TMRID, date)

        setLastSevenDays(priorSevenDays)
        
        
        setVolume(volumeData)
        setFieldsData(fields);

        if (fields.length === 0) {
          // Fetch the most recent date available
          // const mostRecentDate = await fetchMostRecentDate(selectedFeedlot.TMRID);
          // setRecentDate(mostRecentDate);
          setError(`No available data for the selected date. Please choose a different date.`);
          setAlert(null)
        } else {
          const combinedValues = fetchCombinedValuesForDate(fields, fieldsToSum);
          setCombinedData(combinedValues);
          setError(null); // Clear the error after a successful fetch
          setAlert(null); // Clear the error after a successful fetch
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        
        setError('Select a TMRO Feedlot');
        setAlert(null)
      }
    }  else {
      setAlert('Select a Feedlot to display the data.');
    }
  };

  // const fetchMostRecentDate = async (feedlotId) => {
  //   // Placeholder function to fetch the most recent date with available data
  //   // Replace with actual implementation
  //   return '2024-07-01';
  // };
  useEffect(() => {
    fetchData();
  }, [selectedDate, selectedFeedlot]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 bg-gray-900 h-fit p-3">
      {/* Welcome Section */}
      <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-gradient-to-r from-[#2f4858] to-[#33658a] p-6 rounded-lg shadow-3xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h1 className="text-3xl font-bold mb-2 lg:mb-0">TMR Optimizer Dashboard</h1>
            <p className="text-lg">Explore detailed graphs and historical data for each component.</p>
          </div>
          <div className="mt-4 lg:mt-0 shadow-3xl rounded-lg">
          <Link to="/about">
      <button className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
        Learn More
      </button>
    </Link>
          </div>
        </div>
      </div>

      {/* Date Picker */}
      <div className="col-span-2 md:col-span-1 lg:col-span-1 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl z-10 flex flex-col items-center">        
        <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Date:</h2>
        <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="yyyy/MM/dd"
            placeholderText="yyyy/mm/dd"
            className="bg-transparent outline-none w-full"
          />
                   <svg className="w-8 h-8 text-gray-100 cursor-pointer" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> 
            <path d="M7.75 2.5C7.75 2.08579 7.41421 1.75 7 1.75C6.58579 1.75 6.25 2.08579 6.25 2.5V4.07926C4.81067 4.19451 3.86577 4.47737 3.17157 5.17157C2.47737 5.86577 2.19451 6.81067 2.07926 8.25H21.9207C21.8055 6.81067 21.5226 5.86577 20.8284 5.17157C20.1342 4.47737 19.1893 4.19451 17.75 4.07926V2.5C17.75 2.08579 17.4142 1.75 17 1.75C16.5858 1.75 16.25 2.08579 16.25 2.5V4.0129C15.5847 4 14.839 4 14 4H10C9.16097 4 8.41527 4 7.75 4.0129V2.5Z" fill="#61626E"></path> 
            <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 11.161 22 10.4153 21.9871 9.75H2.0129C2 10.4153 2 11.161 2 12V14C2 17.7712 2 19.6569 3.17157 20.8284C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14V12ZM14 12.25C13.0335 12.25 12.25 13.0335 12.25 14V16C12.25 16.9665 13.0335 17.75 14 17.75C14.9665 17.75 15.75 16.9665 15.75 16V14C15.75 13.0335 14.9665 12.25 14 12.25ZM14 13.75C13.8619 13.75 13.75 13.8619 13.75 14V16C13.75 16.1381 13.8619 16.25 14 16.25C14.1381 16.25 14.25 16.1381 14.25 16V14C14.25 13.8619 14.1381 13.75 14 13.75ZM10.787 12.3071C11.0673 12.4232 11.25 12.6967 11.25 13V17C11.25 17.4142 10.9142 17.75 10.5 17.75C10.0858 17.75 9.75 17.4142 9.75 17V14.8107L9.53033 15.0303C9.23744 15.3232 8.76256 15.3232 8.46967 15.0303C8.17678 14.7374 8.17678 14.2626 8.46967 13.9697L9.96967 12.4697C10.1842 12.2552 10.5068 12.191 10.787 12.3071Z" fill="#61626E"></path> 
          </g>
        </svg>
        </label>
        {/* {error && <div className="bg-red-500 text-white p-2 rounded mb-4">{error}</div>} */}
      </div>

      {/* Feedlot Selection */}
      {feedlots.length > 0 && (
        <div className="col-span-2 lg:col-span-3 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
          <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Feedlot:</h2>
          <select
            className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md"
            onChange={handleFeedlotSelect}
            value={selectedFeedlot ? feedlots.findIndex(feedlot => (feedlot.SarCompID === selectedFeedlot.SarCompID && feedlot.TMRID === selectedFeedlot.TMRID)) : ''}
          >
            <option value="">-- Select a Feedlot --</option>
            {feedlots.map((feedlot, index) => (
              <option key={index} value={index}>
                {feedlot.Name || `Feedlot ${index + 1}`}
              </option>
            ))}
          </select>
        </div>
      )}
      {error && (<div className="col-span-2 md:col-span-3 lg:col-span-4 bg-red-200 text-red-700 p-4 rounded-lg shadow-3xl flex items-center">
        <svg className='className="w-6 h-6 text-gray-100 mr-2' viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>alert_fill</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-286.000000, -240.000000)"> <g id="alert_fill" transform="translate(286.000000, 240.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M15.3137,2 C15.8441,2 16.3529,2.21071 16.7279,2.58579 L21.4142,7.27208 C21.7893,7.64715 22,8.15586 22,8.68629 L22,15.3137 C22,15.8441 21.7893,16.3529 21.4142,16.7279 L16.7279,21.4142 C16.3528,21.7893 15.8441,22 15.3137,22 L8.68629,22 C8.15586,22 7.64715,21.7893 7.27208,21.4142 L2.58579,16.7279 C2.21071,16.3528 2,15.8441 2,15.3137 L2,8.68629 C2,8.15586 2.21071,7.64715 2.58579,7.27208 L7.27208,2.58579 C7.64715,2.21071 8.15586,2 8.68629,2 L15.3137,2 Z M12,15 C11.4477,15 11,15.4477 11,16 C11,16.5523 11.4477,17 12,17 C12.5523,17 13,16.5523 13,16 C13,15.4477 12.5523,15 12,15 Z M12,6 C11.48715,6 11.0644908,6.38604429 11.0067275,6.88337975 L11,7 L11,13 C11,13.5523 11.4477,14 12,14 C12.51285,14 12.9355092,13.613973 12.9932725,13.1166239 L13,13 L13,7 C13,6.44772 12.5523,6 12,6 Z" id="形状" fill="#e81127"> </path> </g> </g> </g> </g></svg>
        {error}
        </div>
      )}

{fieldsData.length > 0 && !error && (
       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 col-span-2 md:col-span-3 lg:col-span-4 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-6 rounded-lg shadow-3xl">
   <h2 className="text-2xl font-bold text-gray-100 mb-2 col-span-4">Data Display</h2>
   
    <div className="mb-6 col-span-4">
      <div className="p-4 border border-gray-700 rounded-md bg-slate-800 col-span-2 mt-6 shadow-3xl mb-4">
      <h3 className="text-lg font-semibold text-gray-200 mb-3">End of Day Data:</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-2 border border-gray-700 rounded-md bg-slate-700">
          <p className="text-sm text-gray-200">
                   <strong>{"LSC Volume "}:</strong> {volume.LSCVolume ? volume.LSCVolume + " Gallons" : "No data available for this day"}
          </p>
        </div>
     </div>

       {Object.keys(combinedData).length > 0 && (
         <div className="p-4 border border-gray-700 rounded-md bg-slate-800 col-span-2 mt-6 shadow-3xl mb-4">
           <h3 className="text-lg font-semibold text-gray-200 mb-3">Combined Data:</h3>
           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
             {fieldsToSum.map((field) => (
               <div key={field} className="p-2 border border-gray-700 rounded-md bg-slate-700">
                 <p className="text-sm text-gray-200">
                   <strong>{field}:</strong> {combinedData[field] + unit(field)}
                 </p>
               </div>
             ))}
           </div>
         </div>
       )}
       <h3 className="text-lg font-semibold text-gray-200 mb-3">Select a Batch:</h3>
       <select className="w-full cursor-pointer p-3 rounded-md bg-slate-700 text-gray-200 border border-gray-500 shadow-md mb-4" onChange={handleBatchSelect}>
         <option value="">-- Select a Batch --</option>
         {fieldsData.map((data) => (
           <option key={data.id} value={data.id}>
             Batch Number: {data.Batch}
           </option>
         ))}
       </select>
       {selectedBatch && (
         <div className="p-4 border border-gray-700 rounded-md bg-slate-800 shadow-3xl">
           <h4 className="font-semibold text-gray-100 mb-2">Batch Number: {selectedBatch.Batch}</h4>
           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             {Object.entries(selectedBatch).map(([key, value]) => (
               <div key={key} className="p-2 border border-gray-700 rounded-md bg-slate-700">
                 <p className="text-sm text-gray-200">
                   <strong>{key}:</strong> {value + unit(key)}
                 </p>
               </div>
             ))}
           </div>
         </div>
       )}
     </div>
      </div>
   )}

      {/* Alert Section */}
      {alert && (
        <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-indigo-200 text-blue-600 p-4 rounded-lg shadow-3xl flex items-center">
          <svg className='className="w-6 h-6 text-gray-100 mr-2' viewBox="0 0 24 24" version="1.1"  fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>information_fill</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-672.000000, -48.000000)" fill-rule="nonzero"> <g id="information_fill" transform="translate(672.000000, 48.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M11.99,10 L11,10 C10.4477,10 10,10.4477 10,11 C10,11.51285 10.386027,11.9355092 10.8833761,11.9932725 L11,12 L11,16.99 C11,17.5106133 11.3938293,17.9392373 11.8999333,17.9940734 L12.01,18 L12.5,18 C13.0523,18 13.5,17.5523 13.5,17 C13.5,16.6710222 13.3411062,16.3791012 13.0958694,16.1968582 L13,16.1338 L13,11.01 C13,10.4893867 12.6060836,10.0607627 12.1000493,10.0059266 L11.99,10 Z M12,7 C11.4477,7 11,7.44772 11,8 C11,8.55228 11.4477,9 12,9 C12.5523,9 13,8.55228 13,8 C13,7.44772 12.5523,7 12,7 Z" id="形状" fill="#2b73da"> </path> </g> </g> </g> </g></svg>
          {alert}
        </div>
      )}

     {/* Data Display */}
       {fieldsData.length > 0  && !error && (
     <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
          <div className="mb-4">
           <h3 className="text-lg font-semibold mb-2">Select a Field to Display (Last 7 Days):</h3>
           <select name='timeSeriesField' className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md mb-4" onChange={handleFieldChange}>
             {last7DayFields.map((field) => (
               <option key={field} value={field}>
                 {field}
               </option>
             ))}
           </select>
           <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl mb-4">
             {<TimeSeriesGraph fieldsData={lastSevenDays} selectedField={selectedFields.timeSeriesField} />}
           </div>
         </div>
         <div className="mb-4">
           <h3 className="text-lg font-semibold mb-2">Select a Field to Display:</h3>
           <select name='field' className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md mb-4" onChange={handleFieldChange}>
             {fieldsToSum.map((field) => (
               <option key={field} value={field}>
                 {field}
               </option>
             ))}
           </select>
           <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl mb-4">
             {fieldsData.length > 0 && <BatchGraph fieldsData={fieldsData} selectedField={selectedFields.field} />}
           </div>
           <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl">
             {fieldsData.length > 0 && <InventoryGainGraph fieldsData={fieldsData} selectedField={selectedFields.field} />}
           </div>
           </div>
         
      </div>
       )}
   
    </div>
  );
};

export default TmroPage;
